/**
 * @author PengWen
 * @description 新能源组织迁移  业务数据的受众/管理范围调整
 * @Date 2023/03/20
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, utils_tool } from '../../../tool';
import { templateConfig, reduxTemplateConfig } from "./bizConfig";
import { WizCard, WizCol, WizRow } from "wiz-components";
let {Session} = utils_tool;
let { WizContainer, WizReduxTemplate } = framework_tool;

class BizDataMoveBizManager extends WizContainer {
    componentName = 'BizDataMoveBizManager';

    constructor(props) {
        super(props);
        this.state = {};
        let initialValue = {};
        const {history} = props;
        if (history.location.record) {
            Session.set('businessDataDetail', history.location.record);
            Session.set('businessId', history.location.record.id);
            initialValue = history.location.record;
        } else if (Session.get('businessDataDetail')) {
            initialValue = Session.get('businessDataDetail') ? Session.get('businessDataDetail') : {};
        }
        this.initialValue = initialValue;
    }

    _handleCMD(nextProps, nextState, key){
        let o = nextProps[key];
        if (o['success']) {
          wizNotice.success(o['msg']);
          return true;
        } else {
          wizNotice.error(o['msg']);
          return false;
        }
    }

    _showTitle(record) {
        let content = <WizCard title={'业务类型'} bodyStyle={{paddingLeft: 20, paddingBottom: 25, paddingTop: 25}}>
            <WizRow>
                <WizCol span={8}>
                    业务类型名称：{record.businessName}
                </WizCol>
            </WizRow>
        </WizCard>
        return content;
    }

    _render() {
        let record = this.initialValue;
        let _reduxTemplateConfig = reduxTemplateConfig({
          templateConfig : templateConfig(this),
          apiDataFormat: {
          },
          record
        })
        return <>{this._showTitle(record)}
        <WizCard title={'业务数据详情'}>
            <WizReduxTemplate {..._reduxTemplateConfig} />
        </WizCard>
        
        </>
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
    }
};
  
export default connect(mapStateToProps)(BizDataMoveBizManager);